import React, { useState, useEffect } from 'react'

//* Translations
import strings from 'translations/strings.json'

//* Utilities
import { getTotal } from './utilities'

//* Styles
import styles from './CartTotals.module.scss'

const CartTotals = ({ cart }) => {
  
  const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
  const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]

    const [ { actualTotal }, setActualTotal ] = useState({ actualTotal: getTotal(cart, LANG) })

    useEffect(() => {

        if(cart !== null && cart !== undefined) {
            const newTotal = getTotal(cart, LANG)
            setActualTotal({ actualTotal: newTotal })
        }

    }, [cart])
    

  return (
    <div className={styles["cart-totals"]}>
        <p className={styles["total-label"]}>{STRINGS_LANG.total}</p>
        <p className={styles["total-value"]}>€ { actualTotal }</p>
    </div>
  )
}

export default CartTotals